export enum SubscriptionType {
    OWN = <any>'OWN',
    STUDENT = <any>'STUDENT',
    TEACHER = <any>'TEACHER'
}
